<form [formGroup]="form">
  <mat-form-field class="w100">
    <mat-label>{{ 'SensorEvent.type'|translate }}</mat-label>
    <mat-select formControlName="type">
      @for (type of actuatorType|transformValueByPredicateFunction:predicatePossibleValueType; track type) {
        <mat-option
          [value]="type.valueForm">
          {{ type.traduction|translate }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  @switch (type$|async) {
    @case (actuatorType.LINEAR_ACTUATOR) {
      <ng-container formGroupName="configTypeLINEAR">
        <div class="diagram-container">
          <!-- SVG di base -->
          <img src="assets/icon/sensor/curvaClimatica.svg" style="margin: 0 60px">

          <!-- Etichette sovrapposte -->
          <div class="label max" [matMenuTriggerFor]="SetMax">
            <mat-card>
              <mat-card-content style="width: 60px;height: 60px;padding: 0;display: flex"
                class="flex-center-center flex-direction-column">
                <div>{{ 'max'|translate }}</div>
                @if (maxValueLinear(); as max) {
                  <div>
                    {{ max }}
                  </div>
                }
              </mat-card-content>
            </mat-card>
          </div>
          <div class="label p1" [matMenuTriggerFor]="SetP1">
            <mat-card>
              <mat-card-content style="width: 150px;height: 60px;padding: 0;display: flex"
                class="flex-center-center flex-direction-column">
                <div class="w100">{{ 'p1'|translate }}</div>
                @if (p1ValueLinear(); as p) {
                  <div style="max-width: 100%;overflow: scroll">
                    (
                    @if (p.x) {
                      <span>
                        @if (p.x.sx) {
                          <span class="font-size-p">{{ p.x.sx }}</span>
                        }
                        @if (p.x.dx) {
                          <span class="font-size-p">&nbsp;|&nbsp;{{ p.x.dx }}</span>
                        }
                      </span>
                    }
                    ,
                    @if (p.y) {
                      <span>
                        @if (p.y.sx) {
                          <span class="font-size-p">{{ p.y.sx }}</span>
                        }
                        @if (p.y.dx) {
                          <span class="font-size-p">&nbsp;|&nbsp;{{ p.y.dx }}</span>
                        }
                      </span>
                    }
                    )
                  </div>

                }
              </mat-card-content>
            </mat-card>
          </div>
          <div class="label x" [matMenuTriggerFor]="SetX">
            <mat-card>
              <mat-card-content style="width: 240px;height: 60px;padding: 0;display: flex;overflow: scroll;"
                class="flex-center-center flex-direction-column">
                <div class="w100">{{ 'x'|translate }}</div>
                <div>

                  @if (xValueLinear(); as command) {
                    @if (command.sx) {
                      <span class="font-size-p">
                        {{ command.sx }}
                      </span>
                    }
                    @if (command.dx) {
                      <span class="font-size-p">
                        &nbsp;|&nbsp;{{ command.dx }}
                      </span>
                    }
                  }
                </div>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="label p2" [matMenuTriggerFor]="SetP2">
            <mat-card>
              <mat-card-content style="width: 150px;height: 60px;padding: 0;display: flex"
                class="flex-center-center flex-direction-column">
                <div>{{ 'p2'|translate }}</div>
                @if (p2ValueLinear(); as p) {
                  <div style="max-width: 100%;overflow: scroll">
                    (
                    @if (p.x) {
                      <span>
                        @if (p.x.sx) {
                          <span class="font-size-p">{{ p.x.sx }}</span>
                        }
                        @if (p.x.dx) {
                          <span class="font-size-p">&nbsp;|&nbsp;{{ p.x.dx }}</span>
                        }
                      </span>
                    }
                    ,
                    @if (p.y) {
                      <span>
                        @if (p.y.sx) {
                          <span class="font-size-p">{{ p.y.sx }}</span>
                        }
                        @if (p.y.dx) {
                          <span class="font-size-p">&nbsp;|&nbsp;{{ p.y.dx }}</span>
                        }
                      </span>
                    }
                    )
                  </div>

                }
              </mat-card-content>
            </mat-card>
          </div>
          <div class="label min" [matMenuTriggerFor]="SetMin">
            <mat-card>
              <mat-card-content style="width: 60px;height: 60px;padding: 0;display: flex"
                class="flex-center-center flex-direction-column">
                <div>{{ 'min'|translate }}</div>
                @if (minValueLinear(); as min) {
                  <div>
                    {{ min }}
                  </div>
                }
              </mat-card-content>
            </mat-card>
          </div>
        </div>
        <div style="margin: 10px 0" [matMenuTriggerFor]="SetCommand">
          <mat-card>
            <mat-card-content style="display: flex" class="flex-center-center flex-direction-column">
              <div class="w100" style="text-align: center">{{ 'command'|translate }}</div>
              <div style="max-width: 100%;overflow: scroll">
                @if (commandValueLinear(); as command) {
                  @if (command.sx) {
                    <span class="font-size-p">
                      {{ command.sx }}
                    </span>
                  }
                  @if (command.dx) {
                    <span class="font-size-p">
                      &nbsp;|&nbsp;{{ command.dx }}
                    </span>
                  }
                }
              </div>
            </mat-card-content>
          </mat-card>
        </div>
        <!--                <div class="svg-box">-->
        <!--                    &lt;!&ndash; viewBox in unità “comode” per i calcoli &ndash;&gt;-->
        <!--                    <svg id="scene" viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg" aria-label="Linea _ \ _ a pendenza variabile">-->
        <!--                        &lt;!&ndash; Path principale &ndash;&gt;-->
        <!--                        <path id="zig" [attr.d]="getPathPredicate()" fill="none" stroke="#000" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/>-->
      <!--                    </svg>-->
    <!--                </div>-->
  </ng-container>
}
@case (actuatorType.EXT_SENSOR) {
  <ng-container formGroupName="configTypeEXT_SENSOR">
    @if (elements|transformValueByPredicateFunction:predicatePossibleValuesSensorElements:('suggested'|translate):('other'|translate); as pValues) {
      <app-auto-complete-form
        class="width-form-field" [title]="'SensorEvent.sensorId'|translate" [itemsGroup]="pValues" appearance="fill"
        [hiddenClearButton]="true"
        formControlName="sourceSensorId">
      </app-auto-complete-form>
    }
    @if ((sourceSensor$|async)|transformValueByPredicateFunction:predicatePossibleValuesInfoName:sensorDataTypes:('suggested'|translate):('other'|translate); as pValues) {
      <app-auto-complete-form
        class="width-form-field" [title]="'SensorEvent.infoName'|translate" [itemsGroup]="pValues" appearance="fill"
        [hiddenClearButton]="true" formControlName="sourceInfoName">
      </app-auto-complete-form>
    }
    @if (elements|transformValueByPredicateFunction:predicatePossibleValuesTargetElements:('suggested'|translate):('other'|translate); as pValues) {
      <app-auto-complete-form
        class="width-form-field" [title]="'SensorEvent.targetElementId'|translate" [itemsGroup]="pValues"
        appearance="fill" [hiddenClearButton]="true" formControlName="targetElementId">
      </app-auto-complete-form>
    }
    @if ((targetElement$|async)|transformValueByPredicateFunction:predicatePossibleValuesTarget; as pValues) {
      <app-auto-complete-form
        class="width-form-field" [title]="'SensorEvent.targetCommandName'|translate" [items]="pValues"
        appearance="fill" [hiddenClearButton]="true" formControlName="targetCommandName">
      </app-auto-complete-form>
    }
  </ng-container>
}
@case (actuatorType.RELAY) {
  <ng-container formGroupName="configTypeRELAY">
    @if (switches|transformValueByPredicateFunction:predicatePossibleValuesSensorElements:('suggested'|translate):('other'|translate); as pValues) {
      <app-auto-complete-form
        class="width-form-field" [title]="'SensorEvent.sensorId'|translate" [itemsGroup]="pValues" appearance="fill"
        [hiddenClearButton]="true" formControlName="objectId">
      </app-auto-complete-form>
    }
    <mat-slide-toggle formControlName="status">{{ (relayIsOnTraduction$|async)!|translate }}
    </mat-slide-toggle>
  </ng-container>
}
@case (actuatorType.LIGHT) {
  <ng-container formGroupName="configTypeLIGHT">
    @if (lights|transformValueByPredicateFunction:predicatePossibleValuesSensorElements:('suggested'|translate):('other'|translate); as pValues) {
      <app-auto-complete-form
        class="width-form-field" [title]="'SensorEvent.sensorId'|translate" [itemsGroup]="pValues" appearance="fill"
        [hiddenClearButton]="true" formControlName="objectId">
      </app-auto-complete-form>
    }
    @if ((light$|async)|transformValueByPredicateFunction:predicateGetTypeLight; as possibleCommands) {
      @switch (possibleCommands) {
        @case (typeLight.RANGE.toString()) {
          <div class="w100">
            <mat-slider style="width: 100%!important;margin: 0;">
              <input matSliderThumb formControlName="level">
            </mat-slider>
          </div>
        }
        @case (typeLight.BINARY.toString()) {
          <mat-slide-toggle formControlName="status">{{ (lightStatusTraduction$|async)!|translate }}
          </mat-slide-toggle>
        }
      }
    }
  </ng-container>
}
@case (actuatorType.SHUTTER) {
  <ng-container formGroupName="configTypeSHUTTER">
    @if (shutters|transformValueByPredicateFunction:predicatePossibleValuesSensorElements:('suggested'|translate):('other'|translate); as pValues) {
      <app-auto-complete-form
        class="width-form-field" [title]="'SensorEvent.sensorId'|translate" [itemsGroup]="pValues" appearance="fill"
        [hiddenClearButton]="true" formControlName="objectId">
      </app-auto-complete-form>
    }
    @if ((shutter$|async)|transformValueByPredicateFunction:predicateGetTypeShutter; as possibleCommands) {
      @switch (possibleCommands) {
        @case (typeShutter.RANGE.toString()) {
          {{ 'SensorEvent.shutter.level'|translate:(shutterLevelTraduction$|async) }}
          <div class="w100">
            <mat-slider style="width: 100%!important;margin: 0;">
              <input matSliderThumb formControlName="level">
            </mat-slider>
          </div>
        }
        @case (typeShutter.BINARY.toString()) {
          <mat-slide-toggle formControlName="status">{{ (shutterStatusTraduction$|async)!|translate }}
          </mat-slide-toggle>
        }
      }
    }
  </ng-container>
}
@case (actuatorType.COMMAND) {
  <ng-container formGroupName="configTypeCOMMAND">
    @if (commands|transformValueByPredicateFunction:predicatePossibleValuesCommands; as pValues) {
      <app-auto-complete-form
        class="width-form-field" [title]="'SensorEvent.sensorId'|translate" [items]="pValues" appearance="fill"
        [hiddenClearButton]="true" formControlName="objectId">
      </app-auto-complete-form>
    }
    @if ((command$|async); as command) {
      @if (command|transformValueByPredicateFunction:predicatePossibleValuesCommand; as pValues) {
        <app-auto-complete-form
          class="width-form-field" [title]="'SensorEvent.command'|translate" [items]="pValues" appearance="fill"
          [hiddenClearButton]="true" formControlName="command">
        </app-auto-complete-form>
      }
      @switch (commandValueType$|async) {
        @default {
          <app-increment-field formControlName="value">

          </app-increment-field>
        }
        @case (possibleCommandInCommandType.bool) {
          <mat-button-toggle-group formControlName="value">
            <mat-button-toggle [value]="0">{{ 'off'|translate }}</mat-button-toggle>
            <mat-button-toggle [value]="1">{{ 'on'|translate }}</mat-button-toggle>
          </mat-button-toggle-group>
        }
      }
    }


  </ng-container>
}

}
</form>


<mat-menu #SetMin="matMenu">
  <form [formGroup]="form" (click)="$event.stopPropagation()">
    <div formGroupName="configTypeLINEAR" style="padding: 0 20px;">
      <app-increment-field title="min" formControlName="minVal">
      </app-increment-field>
    </div>
  </form>
</mat-menu>
<mat-menu #SetMax="matMenu">
  <form [formGroup]="form" (click)="$event.stopPropagation()">
    <div formGroupName="configTypeLINEAR" style="padding: 0 20px;">
      <app-increment-field title="max" formControlName="maxVal">
      </app-increment-field>
    </div>
  </form>
</mat-menu>
<mat-menu #SetP1="matMenu">
  <form [formGroup]="form" (click)="$event.stopPropagation()">
    <div formGroupName="configTypeLINEAR" style="padding: 0 20px;">
      <div formGroupName="p1" style="padding: 0">
        <mat-radio-group formControlName="type">
          <mat-radio-button [value]="PointsTypeValues.FIXED">{{ 'SensorEvent.fixed'|translate }}
          </mat-radio-button>
          <mat-radio-button [value]="PointsTypeValues.FROM_SENSOR">{{ 'SensorEvent.sensorValue'|translate }}
          </mat-radio-button>
        </mat-radio-group>
        @switch (p1Type$|async) {
          @case (PointsTypeValues.FIXED) {
            <div formGroupName="value">
              <app-increment-field title="x" formControlName="x">
              </app-increment-field>
              <app-increment-field title="y" formControlName="y">
              </app-increment-field>
            </div>
          }
          @case (PointsTypeValues.FROM_SENSOR) {
            <div formGroupName="source">
              <div formGroupName="x">
                <div class="w100" style="text-align: center">{{ 'SensorEvent.x'|translate}}</div>
                @if (elements|transformValueByPredicateFunction:predicatePossibleValuesSensorElements:('suggested'|translate):('other'|translate); as pValues) {
                  <app-auto-complete-form
                    class="width-form-field" [title]="'SensorEvent.sensorId'|translate" [itemsGroup]="pValues"
                    appearance="fill" [hiddenClearButton]="true" formControlName="sensorId">
                  </app-auto-complete-form>
                }
                @if ((sourceSensorP1X$|async)|transformValueByPredicateFunction:predicatePossibleValuesInfoName:sensorDataTypes:('suggested'|translate):('other'|translate); as pValues) {
                  <app-auto-complete-form
                    class="width-form-field" [title]="'SensorEvent.infoName'|translate" [itemsGroup]="pValues"
                    appearance="fill" [hiddenClearButton]="true" formControlName="infoName">
                  </app-auto-complete-form>
                }

              </div>
              <mat-divider class="w100"></mat-divider>
              <div formGroupName="y">
                <div class="w100" style="text-align: center">{{ 'SensorEvent.y'|translate }}</div>
                @if (elements|transformValueByPredicateFunction:predicatePossibleValuesSensorElements:('suggested'|translate):('other'|translate); as pValues) {
                  <app-auto-complete-form
                    class="width-form-field" [title]="'SensorEvent.sensorId'|translate" [itemsGroup]="pValues"
                    appearance="fill" [hiddenClearButton]="true" formControlName="sensorId">
                  </app-auto-complete-form>
                }
                @if ((sourceSensorP1Y$|async)|transformValueByPredicateFunction:predicatePossibleValuesInfoName:sensorDataTypes:('suggested'|translate):('other'|translate); as pValues) {
                  <app-auto-complete-form
                    class="width-form-field" [title]="'SensorEvent.infoName'|translate" [itemsGroup]="pValues"
                    appearance="fill" [hiddenClearButton]="true" formControlName="infoName">
                  </app-auto-complete-form>
                }
              </div>
            </div>
          }
        }

      </div>
    </div>
  </form>
</mat-menu>
<mat-menu #SetP2="matMenu">
  <form [formGroup]="form" (click)="$event.stopPropagation()">
    <div formGroupName="configTypeLINEAR" style="padding: 0 20px;">
      <div formGroupName="p2" style="padding: 0">
        <mat-radio-group formControlName="type">
          <mat-radio-button [value]="PointsTypeValues.FIXED">{{ 'SensorEvent.fixed'|translate }}
          </mat-radio-button>
          <mat-radio-button [value]="PointsTypeValues.FROM_SENSOR">{{ 'SensorEvent.sensorValue'|translate }}
          </mat-radio-button>
        </mat-radio-group>
        @switch (p2Type$|async) {
          @case (PointsTypeValues.FIXED) {
            <div formGroupName="value">
              <app-increment-field title="x" formControlName="x">
              </app-increment-field>
              <app-increment-field title="y" formControlName="y">
              </app-increment-field>
            </div>
          }
          @case (PointsTypeValues.FROM_SENSOR) {
            <div formGroupName="source">
              <div formGroupName="x">
                <div class="w100" style="text-align: center">{{ 'SensorEvent.x'|translate }}</div>
                @if (elements|transformValueByPredicateFunction:predicatePossibleValuesSensorElements; as pValues) {
                  <app-auto-complete-form
                    class="width-form-field" [title]="'SensorEvent.sensorId'|translate" [itemsGroup]="pValues"
                    appearance="fill" [hiddenClearButton]="true" formControlName="sensorId">
                  </app-auto-complete-form>
                }
                @if ((sourceSensorP2X$|async)|transformValueByPredicateFunction:predicatePossibleValuesInfoName:sensorDataTypes:('suggested'|translate):('other'|translate); as pValues) {
                  <app-auto-complete-form
                    class="width-form-field" [title]="'SensorEvent.infoName'|translate" [itemsGroup]="pValues"
                    appearance="fill" [hiddenClearButton]="true" formControlName="infoName">
                  </app-auto-complete-form>
                }
              </div>
              <mat-divider class="w100"></mat-divider>
              <div formGroupName="y">
                <div class="w100" style="text-align: center">{{ 'SensorEvent.y'|translate}}</div>
                @if (elements|transformValueByPredicateFunction:predicatePossibleValuesSensorElements:('suggested'|translate):('other'|translate); as pValues) {
                  <app-auto-complete-form
                    class="width-form-field" [title]="'SensorEvent.sensorId'|translate"
                    [itemsGroup]="pValues"
                    appearance="fill" [hiddenClearButton]="true" formControlName="sensorId">
                  </app-auto-complete-form>
                }
                @if ((sourceSensorP2Y$|async)|transformValueByPredicateFunction:predicatePossibleValuesInfoName:sensorDataTypes:('suggested'|translate):('other'|translate); as pValues) {
                  <app-auto-complete-form
                    class="width-form-field" [title]="'SensorEvent.infoName'|translate" [itemsGroup]="pValues"
                    appearance="fill" [hiddenClearButton]="true" formControlName="infoName">
                  </app-auto-complete-form>
                }
              </div>
            </div>
          }
        }

      </div>
    </div>
  </form>
</mat-menu>
<mat-menu #SetX="matMenu">
  <form [formGroup]="form" (click)="$event.stopPropagation()">
    <div formGroupName="configTypeLINEAR" style="padding: 0 20px;">
      @if (elements|transformValueByPredicateFunction:predicatePossibleValuesSensorElements:('suggested'|translate):('other'|translate); as pValues) {
        <app-auto-complete-form
          class="width-form-field" [title]="'SensorEvent.sensorId'|translate" [itemsGroup]="pValues" appearance="fill"
          [hiddenClearButton]="true" formControlName="x_sourceId">
        </app-auto-complete-form>
      }
      @if ((sourceSensorX$|async)|transformValueByPredicateFunction:predicatePossibleValuesInfoName:sensorDataTypes:('suggested'|translate):('other'|translate); as pValues) {
        <app-auto-complete-form
          class="width-form-field" [title]="'SensorEvent.infoName'|translate" [itemsGroup]="pValues" appearance="fill"
          [hiddenClearButton]="true" formControlName="x_infoName">
        </app-auto-complete-form>
      }
    </div>
  </form>
</mat-menu>
<mat-menu #SetCommand="matMenu">
  <form [formGroup]="form" (click)="$event.stopPropagation()">
    <div formGroupName="configTypeLINEAR" style="padding: 0 20px;width: 300px">
      @if (elements|transformValueByPredicateFunction:predicatePossibleValuesCommandsGroup:('suggested'|translate):('other'|translate); as pValues) {
        <app-auto-complete-form
          class="width-form-field" [title]="'SensorEvent.sensorId'|translate" registerOnChangeKeyValue="valueForm"
          [itemsGroup]="pValues" appearance="fill" [hiddenClearButton]="true" formControlName="objectId">
        </app-auto-complete-form>
      }
      @if ((commandLinear$|async); as command) {
        @if (command|transformValueByPredicateFunction:predicatePossibleValuesElementTypeCommand; as pValues) {
          <app-auto-complete-form
            class="width-form-field" [title]="'SensorEvent.command'|translate" [items]="pValues" appearance="fill"
            registerOnChangeKeyValue="valueForm" [hiddenClearButton]="true" formControlName="command">
          </app-auto-complete-form>
        }
      }
    </div>
  </form>
</mat-menu>